<template lang="pug">
  .notice.has-text-left
    .notices
      h2.title.is-block-desktop-only NETWORK NOTICES
      div.network-notice.is-block-desktop-only.is-hidden-touch(v-for="(v, k) of filteredNotices", :key="k", tabindex="-2")
          .notice-heading
            .notice-title {{ v.title }}
          .notice-description {{ v.description }}
      bulma-accordion(dropdown).is-hidden-desktop
        bulma-accordion-item.faq-type(v-for="(v, k) of filteredNotices", :key="k", tabindex="-2")
          .notice-heading(slot="title")
            .notice-title {{ v.title }}
          .notice-description(slot="content") {{ v.description }}
</template>

<script>
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  // import VueMoment from 'vue-moment'

  export default {
    components: {
      BulmaAccordion,
      BulmaAccordionItem
    },
    data() {
      return {
        notices: []
      }
    },
    computed: {
      filteredNotices() {
        const now = new Date();
        const filteredNotices = this.notices.filter(notice => (new Date(notice.enddate) > now) &&
            (new Date(notice["reveal date"]) < now));
        return filteredNotices;
      }
    },
    mounted() {
      this.$http.get(`${process.env.VUE_APP_BACKEND_URL}notices`)
        .then(notices => {
          console.log("Get notices: ", notices.data);
          this.notices = notices.data
        })
    }
  }
</script>

<style lang="scss">
  @import "../styles/variables";
  @import "~bulma/sass/utilities/mixins";

  .notice {
    padding: 3rem;
    display: flex;

    @include until($desktop) {
      flex-direction: column;
    }

    .notices {
      flex: 1;
      flex-basis: 75%;

      .notice-heading {
        float: left;
        width: 100%;
        .notice-title {
          float: left;
        }
      }
      .notice-description {
        width: 100%;
        font-weight: normal;
        margin-top: 1rem;
      }

      @include from($desktop) {
        .network-notice {
          background-color: white;
          border-radius: 0;
          -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
          box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
          color: $secondary-colour;
          display: block;
          padding: 3rem;
          width: 100%;
          float: left;
        }
      }

      @include until($desktop) {
        .notice-heading {
          .notice-title {
            float: left;
            width: 100%;
          }
        }
        .notice-description {
          // margin: 0.2rem;
          margin: 0;
          padding: 1rem 1rem;
        }
      }

      .faq-type {
        background-color: rgb(250, 250, 250);
        cursor: pointer;
        // position: relative;
        font-weight: normal;
        margin: 0.2rem;
        outline: none;
        margin-bottom: 1em;

        .faq-type-name {
          text-transform: uppercase;
          display: flex;
          padding: 0.5rem 1rem;

          .faq-type-title {
            flex: 1;
          }

          .faq-icon {
            align-self: center;
          }
        }

        .faq-option {
          padding: 0.5rem 1rem;
          display: block;
          color: $secondary-colour;

          &:hover {
            background-color: $primary-colour;
            color: #FFF;
          }
        }

        .card-content {
          padding: 0;
        }
      }
    }

    .faq-contact-us {
      flex: 1;
      flex-basis: 50%;

      @include from($desktop) {
        margin-left: 3rem;
      }

      .faq-contact-box {

        .faq-button {
          border-radius: 0;
          padding: 1.25rem 2rem;
          line-height: 0;
        }

        @include from($desktop) {
          background-color: white;
          border-radius: 6px;
          -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
          box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
          color: #231f20;
          display: block;
          padding: 3rem;
        }
      }
    }
  }
</style>
